import { API_PUBLISHED_ON_PATH, getClient } from '../api';
import { PublishedOn, PublishedOnBatch } from '../dtos';

export async function updatePublishedOns(publishedOnBatch: PublishedOnBatch): Promise<PublishedOnBatch> {
  const client = await getClient();
  const { data } = await client.put<PublishedOnBatch>(API_PUBLISHED_ON_PATH, publishedOnBatch);

  return data;
}

export async function updatePublishedOn(publishedOn: PublishedOn): Promise<PublishedOn> {
  const client = await getClient();
  const { data } = await client.put<PublishedOn>(`${API_PUBLISHED_ON_PATH}/${publishedOn.id}`, publishedOn);

  return data;
}
